import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import { IBulkShipmentProfilesSlice } from "./bulkShipmentProfilesSlice.interface";

export const BulkShipmentProfilesInitialState: IBulkShipmentProfilesSlice = {
  loadingStatus: ApiLoadingStatus.IDLE,
  profiles: [],
};
